import Vue from "vue";
import App from "./App.vue";
import router from "./router-editor";
import store from "./store/index";

Vue.config.productionTip = false;

import shortkey from "vue-shortkey";
Vue.use(shortkey, { prevent: ["input", "textarea", ".avoid-shortkey-class"] });

import VueDarkMode from "vuedarkmode";
Vue.use(VueDarkMode);

import VDragged from "v-dragged";
Vue.use(VDragged);

import VueDraggableResizable from "vue-draggable-resizable";
// optionally import default styles
import "vue-draggable-resizable/dist/VueDraggableResizable.css";
Vue.component("vue-draggable-resizable", VueDraggableResizable);

import * as Sentry from "@sentry/browser";
import * as Integrations from "@sentry/integrations";

if (process.env.NODE_ENV === "production") {
  // Only use Sentry in production builds.
  Sentry.init({
    dsn: "https://b8d3244f77544c549e6249a3fb8c38cd@sentry.io/1440317",
    integrations: [
      new Integrations.Vue({
        Vue,
        attachProps: true
      })
    ],
    release: process.env.VUE_APP_GIT_REV
  });
}

// only import the icons you use to reduce bundle size
import "vue-awesome/icons/thumbtack";
import "vue-awesome/icons/lock";
import "vue-awesome/icons/map-pin";
import "vue-awesome/icons/map-marker";
import "vue-awesome/icons/video";
import "vue-awesome/icons/arrows-alt";
import "vue-awesome/icons/check-circle";

// These are used in the editor AND the player.
// Make sure to add to main-editor and main-player.
import "vue-awesome/icons/link";
import "vue-awesome/icons/external-link-alt";
import "vue-awesome/icons/play";
import "vue-awesome/icons/pause";
import "vue-awesome/icons/info";

import Icon from "vue-awesome/components/Icon";

// globally (in your main .js file)
Vue.component("v-icon", Icon);

// Globally import some css.
import "@/scss/padding-margin-extras.css";

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount("#app");
